import React from 'react'
import './Knowledge_Blog.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendar } from '@fortawesome/free-solid-svg-icons'

const Knowledge_Blog = () => {
    return (
        <section className='Knowledge_Blog'>
            <div className='container'>
                <p className='commontitle'>The <span className='red_text'>DPU-COL</span> Knowledge Blog</p>

                <div className='row'>

                    <div className='col-sm-6'>
                        <div className='blog_card'>
                            <div className='img_holder'>
                                <img src='/assets/images/home/knowledge_blog/img1.png' className='blog_img' />
                            </div>
                            <div className='text_holder'>
                                <p className='date_text'><FontAwesomeIcon icon={faCalendar} className='icon' />23 May 2025</p>
                                <p className='descn_text'>Master SEO, PPC & Social Media with DPU- COL’s Online MBA in Digital Marketing</p>
                            </div>
                            <div className='overlay'></div>
                        </div>
                    </div>

                    <div className='col-sm-6'>
                        <div className='blog_card'>
                            <div className='img_holder'>
                                <img src='/assets/images/home/knowledge_blog/img2.png' className='blog_img' />
                            </div>
                            <div className='text_holder'>
                                <p className='date_text'><FontAwesomeIcon icon={faCalendar} className='icon' />23 May 2025</p>
                                <p className='descn_text'>Launch a High-Growth Career in Digital Marketing</p>
                            </div>
                            <div className='overlay'></div>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    )
}

export default Knowledge_Blog
